import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import classnames from "classnames";

import OfferIcons from "@components/icons/Offer";

export default observer(function BetBuilderPicksFilterBar() {
	const rootStore = useRootAppStore();
	if (
		rootStore.quickPlayStore.betBuilderPicksStore.sportCategories.length ==
		1
	) {
		return null;
	}

	return (
		<div className="tabs--primary tabs--groups u-mar--top--xtny">
			{rootStore.quickPlayStore.betBuilderPicksStore.sportCategories.map(
				(sport) => {
					const buttonClasses = classnames(
						"tabs--groups__item btn btn--sml btn--icon",
						{
							"btn--tertiary":
								rootStore.quickPlayStore.betBuilderPicksStore
									.selectedSportCategory?.sportAbrv !=
								sport.sportAbrv,
							"btn--secondary is-active":
								rootStore.quickPlayStore.betBuilderPicksStore
									.selectedSportCategory?.sportAbrv ==
								sport.sportAbrv,
						}
					);

					const iconClasses = classnames("tabs--groups__icon", {
						"is-framed":
							rootStore.quickPlayStore.betBuilderPicksStore
								.selectedSportCategory?.sportAbrv ==
							sport.sportAbrv,
					});

					return (
						<button
							className={buttonClasses}
							onClick={() =>
								rootStore.quickPlayStore.betBuilderPicksStore.filterByCategory(
									sport.sportAbrv
								)
							}
							key={sport.sportAbrv}
						>
							<span className={iconClasses}>
								<OfferIcons
									type="sport"
									sport={sport.sportAbrv || ""}
									wrapperClassName={iconClasses}
									className="u-icon u-icon--med"
								/>
							</span>
							<span className="u-type--sml">
								{sport.sportName}
							</span>
						</button>
					);
				}
			)}
		</div>
	);
});
